<div class="ml-5">
  <p id="index-des-formations" class="titre1 m-4">
    {{ 'INDEX_FORMATION.INDEX_FORMATION' | translate }}
    <mat-icon class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">school</mat-icon>
  </p>
  <div class="overflow-x-auto">
    @if (isLoading) {
      <div class="flex justify-center items-center h-64">
        <mat-spinner color="accent"></mat-spinner>
      </div>
    }
    @if (!isLoading) {
      <div>
        <div class="flex items-center justify-end mb-4 gap-3">
          <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()"
            placeholder="{{ 'INDEX_FORMATION.SEARCH' | translate }}..."
            class="h-8 w-64 rounded-md border-w-2 border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200">
            <button mat-icon-button (click)="resetFilter()" class="h-1/12 w-8 bg-white-200 text-white-600 rounded">
              <mat-icon>restore</mat-icon>
            </button>
          </div>
          <table mat-table [dataSource]="filteredFormations" matSort class="mat-table-novo w-full">
            <ng-container matColumnDef="nomFormation">
              <th mat-header-cell *matHeaderCellDef class="table-cell px-4 py-2 dark:bg-gray-800 dark:text-white">
                {{ 'INDEX_FORMATION.NOM_FORMATION' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b dark:bg-gray-900 dark:text-white">
                <a [routerLink]="['/index-formation', element.nomFormation]"
                  class="text-blue-600 underline hover:text-blue-800">
                  {{ element.nomFormation }}
                </a>
              </td>
            </ng-container>
            <ng-container matColumnDef="nomFR">
              <th mat-header-cell *matHeaderCellDef class="table-cell px-4 py-2 dark:bg-gray-800 dark:text-white">
                {{ 'INDEX_FORMATION.NOM_FR' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b dark:bg-gray-900 dark:text-white">
                {{ element.nomFR }}
              </td>
            </ng-container>
            <ng-container matColumnDef="nomEN">
              <th mat-header-cell *matHeaderCellDef class="table-cell px-4 py-2 dark:bg-gray-800 dark:text-white">
                {{ 'INDEX_FORMATION.NOM_EN' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b dark:bg-gray-900 dark:text-white">
                {{ element.nomEN }}
              </td>
            </ng-container>
            <ng-container matColumnDef="nomES">
              <th mat-header-cell *matHeaderCellDef class="table-cell px-4 py-2 dark:bg-gray-800 dark:text-white">
                {{ 'INDEX_FORMATION.NOM_ES' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b dark:bg-gray-900 dark:text-white">
                {{ element.nomES }}
              </td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef class="table-cell px-4 py-2 dark:bg-gray-800 dark:text-white">
                {{ 'INDEX_FORMATION.TYPE' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b dark:bg-gray-900 dark:text-white">
                {{ element.type }}
              </td>
            </ng-container>
            <ng-container matColumnDef="dureeMinutes">
              <th mat-header-cell *matHeaderCellDef class="table-cell px-4 py-2 dark:bg-gray-800 dark:text-white">
                {{ 'INDEX_FORMATION.DUREE_MINUTES' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b dark:bg-gray-900 dark:text-white">
                {{ element.dureeMinutes !== null ? element.dureeMinutes : '-' }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          @if (filteredFormations.length === 0) {
            <div class="text-center mt-2 text-gray-500 dark:text-gray-400">
              {{ 'INDEX_FORMATION.AUCUN_RESULTAT' | translate }}
            </div>
          }
        </div>
      }
    </div>
  </div>